"use client";

import FAQSection from "@/components/FAQ/FAQSection";
import { PageSection } from "@components";
import { singularBtbFAQ } from "./constants";

const SingularFAQSection = () => {
  return (
    <PageSection>
      <FAQSection
        blockName="FAQ's"
        questions={singularBtbFAQ}
        maxQuestionsWithoutExpand={5}
        headerClassName="text-center"
      />
    </PageSection>
  );
};

export default SingularFAQSection;
